import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { CityPage } from './pages/CityPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/:cityName" element={<CityPage />} />
    </Routes>
  );
}

export default App;